import React from "react";
import Breadcrumb from "../../Breadcrumb/Main";
import Header from "../../headerone/Main";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import LeftEvents from "./LeftEvents";
import { Carousel } from "react-responsive-carousel";
import styles from "react-responsive-carousel/lib/styles/carousel.min.css";
import { useState } from "react";

export default function DistinguishedLectures() {
    const Data = [
        {
            venue: "IIT Tirupati",
            title: "Dimensionality of Chemistry",
            description:
                'Lecture on "Dimensionality of Chemistry - A 21st Century Science for Global Sustainability” by Professor Goverdhan Mehta, University Distinguished Professor & Dr. Kallam Anji Reddy Chair, School of Chemistry, University of Hyderabad. ',
            img: [
                "https://files.iittp.ac.in/pics/dimchem/1.jpg",
                "https://files.iittp.ac.in/pics/dimchem/2.jpg",
                "https://files.iittp.ac.in/pics/dimchem/3.jpg",
                "https://files.iittp.ac.in/pics/dimchem/4.jpg",
            ],
            dt: "27",
            my: "Dec 2020",
            category: "2020",
        },
        {
            venue: "IIT Tirupati",
            title: "Scaling Laws",
            description:
                "Lecture on “Scaling Laws: The Science of Miniaturization” by Professor Amitbha Ghosh, Former Director, Indian Institute of Technology Kharagpur.",
            img: [
                "https://files.iittp.ac.in/pics/scalinglaws/1.jpg",
                "https://files.iittp.ac.in/pics/scalinglaws/2.jpg",
            ],
            dt: "2",
            my: "Dec 2020",
            category: "2020",
        }, //TODO: Add Images to the following events
        {
            venue: "IIT Tirupati",
            title: "Invitation to Inverse Problems",
            description:
                "Lecture on “Invitation to Inverse Problems” by Prof. Gen Nakamura, Professor Emeritus of Hokkaido University, Japan ",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/profNakamura/NakamuraTalk.PNG",
                "https://files.iittp.ac.in/images/demo/iit/Events/profNakamura/NakamuraTalk-2.PNG",
            ],
            dt: "14",
            my: "Oct 2020",
            category: "2020",
        },
        {
            venue: "IIT Tirupati",
            title: "Digital Technologies: Challenges and Opportunities",
            description:
                'Lecture on "Digital Technologies: Challenges and Opportunities" by Dr. B. V. R. Mohan Reddy, Executive Chairman, Cyient and Chairman, Board of Governors, IIT Hyderabad ',
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/DL/drmohanreddy/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/DL/drmohanreddy/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/DL/drmohanreddy/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/DL/drmohanreddy/4.JPG",
            ],
            dt: "6",
            my: "Feb 2020",
            category: "2020",
        },

        {
            venue: "IIT Tirupati",
            title: "Is the Public Understanding of Science Important?",
            description:
                "Lecture on “Is the Public Understanding of Science Important?” by Professor P. Balaram, Former Director, Indian Institute of Science, Bangalore. ",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/balaram/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/balaram/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/balaram/5.jpg",
            ],
            dt: "18",
            my: "Nov 2019",
            category: "2019",
    
        },
        {
            venue: "IIT Tirupati",
            title: "Engineering Education, Infrastructure and Economy",
            description:
                "Lecture on “Engineering Education, Infrastructure and Economy: Reflections and Lessons from Asian Countries for India’s Journey to become a $5 trillion Economy” by Professor K. E. Seetha Ram, Visiting Professor, University of Tokyo, Japan. ",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/seetharam/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/seetharam/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/seetharam/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/seetharam/4.JPG",
            ],
            dt: "16",
            my: "Oct 2019",
            category: "2019",
        },
        {
            venue: "IIT Tirupati",
            title: "How well do we know our universe?",
            description:
                'Lecture on "How well do we know our universe?" by Prof. Jayant V. Narlikar, Emeritus Professor, Inter-University Centre for Astronomy and Astrophysics, Pune. ',
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/jayant/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/jayant/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/jayant/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/jayant/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/jayant/5.jpg",
                

            ],
            dt: "29",
            my: "Mar 2019",
            category: "2019",
            link: "https://www.youtube.com/watch?v=Jf2YlPdEje0&t=543s"
        },
        {
            venue: "IIT Tirupati",
            title: "A Quantum Leap and a Bright Future",
            description:
                'Lecture on "A Quantum Leap and a Bright Future" by Professor G. Baskaran, Theoretical Physicist, Institute of Mathematical Sciences, Chennai.',
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/quantum/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/quantum/4.jpg"
            ],
            dt: "12",
            my: "Mar 2019",
            category: "2019",
        },
        {
            venue: "IIT Tirupati",
            title: "South India's Role in the Story of India",
            description:
                "Inaugural Lecture by Professor Rajmohan Gandhi (A well known Historian & Biographer) on the topic 'South India's Role in the Story of India'.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/10.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/11.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/12.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/13.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/14.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/distinguishedlectures/17.jpg",



            ],
            dt: "7",
            my: "Jan 2019",
            category: "2019",
            link:"https://www.youtube.com/watch?v=x1PanMm-5m0&t=46s"
        },
        // {
        //     venue: 'IIT Tirupati',
        //     title: '',
        //     description: '',
        //     img: [],
        //     dt: '',
        //     my: '',
        //     category: ''
        // }
    ];
    const [activeButton, setActiveButton] = useState("View All");
    const [current, setcurrent] = useState(Data);

    const Filter = (category) => {
        setActiveButton(category);
        const arr = [];
        if (category === "View All") {
            setcurrent(Data);
        } else {
            Data.map((item) => {
                if (item.category === category) {
                    arr.push(item);
                }
            });
            setcurrent(arr);
        }
    };

    const [expandedDescriptions, setExpandedDescriptions] = useState({});

    // Function to toggle the description expansion
    const toggleDescriptionExpansion = (index) => {
        setExpandedDescriptions({
            ...expandedDescriptions, [index]: !expandedDescriptions[index],
        });
    };
    function chunkArray(array, chunkSize) {
        const chunkedArray = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunkedArray.push(array.slice(i, i + chunkSize));
        }
        return chunkedArray;
    }

    return (
        <div className="distinguished-lectures">
            <Header />
            <Breadcrumb subtitle={"Distinguished Lectures"} title={"Home"} />

            <section className="project-detail">
                <div className="container">
                    <div
                        className="section-title center-align mb-50 wow fadeInDown animated"
                        data-animation="fadeInDown"
                        data-delay=".4s"
                    >
                        <h5>
                            <i className="fal fa-calendar" /> Events
                        </h5>
                        <h2>Distinguished Lectures</h2>
                    </div>
                    <Row>
                        <Col md={4} className="c-left">
                            <LeftEvents activeIndex={0} />
                        </Col>

                        <Col md={8} className="c-left">
                            <div className="row align-items-end">
                                <div className="col-lg-12">
                                    <div
                                        className="my-masonry text-center mb-50 wow fadeInRight animated"
                                        data-animation="fadeInRight"
                                        data-delay=".4s"
                                    >
                                        <div className="button-group filter-button-group ">
                                            <button
                                                className={`${activeButton === "View All"
                                                    ? "active"
                                                    : ""
                                                    }`}
                                                data-filter="*"
                                                onClick={() =>
                                                    Filter("View All")
                                                }
                                            >
                                                {" "}
                                                View All
                                            </button>
                                            <button
                                                className={`${activeButton === "2020"
                                                    ? "active"
                                                    : ""
                                                    }`}
                                                data-filter=".2020"
                                                onClick={() => Filter("2020")}
                                            >
                                                2020
                                            </button>
                                            <button
                                                className={`${activeButton === "2019"
                                                    ? "active"
                                                    : ""
                                                    }`}
                                                data-filter=".2019"
                                                onClick={() => Filter("2019")}
                                            >
                                                2019
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {chunkArray(current, 2).map((row, rowIndex) => (
                                <Row key={rowIndex}>
                                    {row.map((event, index) => (
                                        <Col
                                            key={index}
                                            lg={6}
                                            md={6}
                                            sm={12}
                                            className="wow fadeInUp animated"
                                            data-animation="fadeInUp"
                                            data-delay=".4s"
                                        >
                                            <div className="event-item mb-30 hover-zoomin">
                                                <div className="thumb">
                                                    <Carousel
                                                        showArrows={true}
                                                        showThumbs={false}
                                                        dynamicHeight={false}
                                                        selectedItem={0}
                                                    >
                                                        {event.img.map(
                                                            (
                                                                image,
                                                                imgIndex
                                                            ) => (
                                                                <div
                                                                    key={
                                                                        imgIndex
                                                                    }
                                                                >
                                                                    <img
                                                                        src={
                                                                            image
                                                                        }
                                                                        alt={`event-img-${imgIndex}`}
                                                                    />
                                                                </div>
                                                            )
                                                        )}
                                                    </Carousel>
                                                </div>
                                                <div className="event-content">
                                                    <div className="date">
                                                        <strong>
                                                            {event.dt}
                                                        </strong>{" "}
                                                        {event.my}
                                                    </div>
                                                    <h3
                                                        style={{
                                                            minHeight: "87px",
                                                        }}
                                                    >
                                                        <Link to="/single-event">
                                                            {" "}
                                                            {event.title}
                                                        </Link>
                                                    </h3>
                                                    <p>{event.description}</p>
                                                    <div className="time">
                                                        {event.duration}{" "}
                                                        <i className="fal fa-long-arrow-right" />{" "}
                                                        <strong>
                                                            {event.venue}
                                                        </strong>
                                                    </div>

                                                    <div> 
                                                        {event.link && event.link !== '' ? (
                                                            <p>To view the complete lecture : <Link className="c-link" to ={event.link} > Click here </Link> </p>
                                                        ) : (
                                                            <p>  </p>
                                                        )}
                                                    </div>

                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            ))}
                        </Col>
                    </Row>
                </div>
            </section>
        </div>
    );
}
